var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47173 1.80482C6.73208 1.54447 6.73208 1.12236 6.47173 0.86201C6.21138 0.601661 5.78927 0.601661 5.52892 0.86201L0.862254 5.52868C0.601905 5.78903 0.601905 6.21114 0.862254 6.47149L5.52892 11.1382C5.78927 11.3985 6.21138 11.3985 6.47173 11.1382C6.73208 10.8778 6.73208 10.4557 6.47173 10.1953L2.94314 6.66675H10.667C11.0352 6.66675 11.3337 6.36827 11.3337 6.00008C11.3337 5.63189 11.0352 5.33342 10.667 5.33342H2.94313L6.47173 1.80482Z",
    fill: "#5578BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.16ef801717584cb8cdbd8efd87be0a87.svg";
export { ForwardRef as ReactComponent };